import React from 'react';
import Hotels from './Hotels';

const Villa = () => {
  return (
    <Hotels initialCategory="villa" hideCategoryFilters={true} />
  );
};

export default Villa;


